import { render, staticRenderFns } from "./AdmissionsReport.vue?vue&type=template&id=8baacc3c&"
import script from "./AdmissionsReport.vue?vue&type=script&lang=js&"
export * from "./AdmissionsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports